import React from 'react'

import { InstitutionLogo, P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'

interface MiniBodyHeaderProps {
  account: { guid: string; logo_alt_text: string }
  headerString: string
}

export const MiniBodyHeader: React.FC<MiniBodyHeaderProps> = ({ account, headerString }) => {
  const logoSize = 20

  return (
    <Box
      data-ui-test="mx-insights-sudd-mini-body-header"
      sx={{ display: 'flex', flexDirection: 'row', gap: 8, justifyContent: 'center' }}
    >
      <InstitutionLogo
        alt={account.logo_alt_text || 'Financial Institution Logo'}
        data-ui-test="mx-insights-sudd-mini-body-header-logo"
        height={logoSize}
        institutionGuid={account.guid || ''}
        width={logoSize}
      />
      <P bold={true} data-ui-test="mx-insights-sudd-mini-body-header-text">
        {headerString}
      </P>
    </Box>
  )
}
